// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact {
  max-width: 800px;
  margin: 0 auto;
  padding: 60px 40px 80px;
  text-align: center;
}

.contact-title {
  font-family: var(--font-display);
  font-size: clamp(48px, 8vw, 100px);
  color: var(--gold);
  text-transform: uppercase;
  line-height: 1;
  margin-bottom: 16px;
}

.contact-subtitle {
  font-family: var(--font-body);
  font-size: clamp(14px, 1.4vw, 20px);
  color: var(--dark);
  opacity: 0.7;
  margin-bottom: 60px;
}

.contact-content {
  display: flex;
  justify-content: center;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 36px;
  text-align: left;
}

.contact-item h3 {
  font-family: var(--font-body);
  font-size: 14px;
  font-weight: 700;
  color: var(--dark);
  opacity: 0.5;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.contact-item a,
.contact-item p {
  font-family: var(--font-body);
  font-size: 22px;
  color: var(--dark);
  transition: color 0.3s ease;
}

.contact-item a:hover {
  color: var(--gold);
}

@media (max-width: 768px) {
  .contact {
    padding: 32px 16px 60px;
  }

  .contact-subtitle {
    margin-bottom: 40px;
  }

  .contact-item a,
  .contact-item p {
    font-size: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Contact.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;EACjB;AACF","sourcesContent":[".contact {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 60px 40px 80px;\n  text-align: center;\n}\n\n.contact-title {\n  font-family: var(--font-display);\n  font-size: clamp(48px, 8vw, 100px);\n  color: var(--gold);\n  text-transform: uppercase;\n  line-height: 1;\n  margin-bottom: 16px;\n}\n\n.contact-subtitle {\n  font-family: var(--font-body);\n  font-size: clamp(14px, 1.4vw, 20px);\n  color: var(--dark);\n  opacity: 0.7;\n  margin-bottom: 60px;\n}\n\n.contact-content {\n  display: flex;\n  justify-content: center;\n}\n\n.contact-info {\n  display: flex;\n  flex-direction: column;\n  gap: 36px;\n  text-align: left;\n}\n\n.contact-item h3 {\n  font-family: var(--font-body);\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--dark);\n  opacity: 0.5;\n  text-transform: uppercase;\n  margin-bottom: 4px;\n}\n\n.contact-item a,\n.contact-item p {\n  font-family: var(--font-body);\n  font-size: 22px;\n  color: var(--dark);\n  transition: color 0.3s ease;\n}\n\n.contact-item a:hover {\n  color: var(--gold);\n}\n\n@media (max-width: 768px) {\n  .contact {\n    padding: 32px 16px 60px;\n  }\n\n  .contact-subtitle {\n    margin-bottom: 40px;\n  }\n\n  .contact-item a,\n  .contact-item p {\n    font-size: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
